import { BelpostUserType } from '$shared/types/belpost-contact';

export type WidgetIndividualType = 'individual';

export type WidgetUserLegalType = 'legal' | 'individual-entrepreneur';

/**
 * Соответствие типов адресов между виджетом и Belpost.
 */
export const WIDGET_USER_TYPE_MAP: Record<
  BelpostUserType,
  WidgetIndividualType | WidgetUserLegalType
> = {
  legal: 'legal',
  individual: 'individual',
  individual_entrepreneur: 'individual-entrepreneur',
};

/**
 * Трансформирует тип пользователя из Belpost в тип виджета
 * @param belpostUserType - Тип пользователя из Belpost
 * @returns Тип пользователя для виджета
 * @throws Error если тип не поддерживается
 */
export function transformBelpostUserTypeToWidgetUserType(
  belpostUserType: BelpostUserType
): WidgetIndividualType | WidgetUserLegalType {
  const widgetType = WIDGET_USER_TYPE_MAP[belpostUserType];

  if (!widgetType) {
    throw new Error(
      `Неподдерживаемый тип пользователя Belpost: ${belpostUserType}`
    );
  }

  return widgetType;
}
